module.exports = __webpack_public_path__ + "static/media/Traffic Signal.8ff60084.png";